// extracted by mini-css-extract-plugin
module.exports = {"Container":"AdminAffiliateDash_Container__NhPiD"};